import React, { useEffect, useState } from 'react'
import Config from '../Config';
import Cookies from 'js-cookie';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuthHandling } from '../useAuthhandling';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';

function Faqview() {
    let navigate = useNavigate();
    const { isAuthorized, handleUnauthorized } = useAuthHandling();
  
    const tokens = Cookies.get("a_token");
    if (!tokens) {
      navigate("/");
    }
    let { id } = useParams();
  
    const [faq, setFaq] = useState([]);
  
  
    const getinfo = async (e) => {
      const res = await fetch(`${Config.apiurl}/api/v1/crm/faq/get-faq/${id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      });
      if (res.status === 200 ) {
        const data = await res.json();
  
        setFaq(data.data);
  
      } 
      else if(res.status === 401){
        handleUnauthorized();
        getinfo();
      }
      else {
        alert("error");
  
      }
    };

    useEffect(() => {
        getinfo();
      }, []);
  return (
    <div className="container-scroller">
            <Navbar />

            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <div className='view_page_top'>
                            <Link to="/faq">Faq list</Link>
                            <Link to={"/editfaq/" + id}>Edit</Link>
                        </div>
                        <div className="row">
                            <div className="col-md-12 grid-margin stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title">Faq View page</h4>

                                        <div className='row view_div_row'>
                                            <div className='col-12 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6>Question </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p> {faq.faqTitle}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-12'>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Answer </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p>  {faq.faqBody}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6>Status </h6>
                                                    </div>

                                                    <div className='view_portion_p'>
                                                        <p>  {faq.status === true ? "True" : "False"}</p>
                                                    </div>

                                                </div>
                                            </div>
                                           
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default Faqview
